import { SetStateAction } from "react";

function blurHandler(setBottomPadding: (value: SetStateAction<number>) => void) {
  setBottomPadding(0);
}

export default blurHandler;
